import { toast } from '@core/toast';
import { extractApiErrorMessage } from '@core/utils/errors';

export function useError() {
    function showError(error: unknown) {
        const message = extractApiErrorMessage(error, 'There was an error');
        console.error(message);
        toast.error(message);
    }

    return showError;
}
